import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, setToken, formatApiErrorDetail } from "../lib/apiClient";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [token, setTokenVal] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/accept-invite", { token: token.trim(), password });
      if (data.token) setToken(data.token);
      const me = await api.get("/auth/me");
      setUser(me.data);
      toast.success("Welcome to the team!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F9F8F6]" data-testid="accept-invite-page">
      <div className="hidden lg:flex flex-col items-center justify-center text-center bg-white border-r border-[#EBE5E0] p-12">
        <h1 className="font-serif text-6xl text-[#A68A6B] leading-none mb-5">WorkRoom</h1>
        <p className="font-serif text-2xl text-[#2B2622]">Join your studio's workspace</p>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="accept-invite-form">
          <div>
            <h2 className="font-serif text-3xl text-[#2B2622]">Accept your invite</h2>
            <p className="text-sm text-[#5C5651] mt-1">Set a password to access your studio's projects.</p>
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-[#5C5651]">Invite token</Label>
            <Input data-testid="invite-token-input" value={token} onChange={(e) => setTokenVal(e.target.value)} required
              className="mt-1 rounded-none border-[#EBE5E0] focus-visible:ring-0 focus-visible:border-[#A68A6B]" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider text-[#5C5651]">Create password</Label>
            <Input data-testid="invite-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="mt-1 rounded-none border-[#EBE5E0] focus-visible:ring-0 focus-visible:border-[#A68A6B]" />
          </div>
          <Button data-testid="accept-invite-submit" type="submit" disabled={busy}
            className="w-full rounded-none bg-[#A68A6B] hover:bg-[#8C7154] text-white uppercase tracking-wider text-xs py-5">
            {busy ? "Setting up…" : "Join studio"}
          </Button>
        </form>
      </div>
    </div>
  );
}
